import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { AbstractPage } from '../../_com/abstract-page';
import { SignatureEditPage } from '../edit/signature-edit'
import { StaffAction } from '../../../actions/staff.action';

/**
 * Generated class for the StaffListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-signature-detail',
  templateUrl: 'signature-detail.html',
})
export class SignatureDetailPage extends AbstractPage{

  signatureText:any;
  text = "";
  isSignatureTextExists:Boolean;
  constructor(
  	public navCtrl: NavController,
    public navParams: NavParams,
    public viewController:ViewController,
    public alertController:AlertController,
  	public staffAction:StaffAction,
  	) {
    super();
    this.refresh();
  }

    /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    this.refresh();
  }

  ionViewDidEnter() {
    this.refresh();
  }

  refresh() {
    this.staffAction.getSignMessage().subscribe((res)=>{
      // ここでデータを取得する
      if (res.data.length > 0) {
        this.signatureText = res.data[0]['SignText'];
        this.text          = res.data[0]['SignText']['sign_text'];
        this.isSignatureTextExists = true;
      } else {
        this.signatureText         = false;
        this.isSignatureTextExists = false;
      }
    });
  }

  toEditSignatureText() {
    let data = {
      signatureText: this.signatureText,
      isDataExists: this.isSignatureTextExists
    };
    this.navCtrl.push(SignatureEditPage, data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signature/detail/signature-detail.ts